import ArticleTable from './ArticleTable';
export default ArticleTable;